import { withI18nPlaceholders } from '@change-corgi/core-react/i18n';

import I18N_PLACEHOLDERS from '#config/i18n/placeholders/homepage/homepage.yml';

import { Homepage as HomepageBase } from './entryPoint';

// Temporary: the beautification strings are in config/i18n/corgi.en-US.yml and waiting on
// translation, and an untranslated key renders as the raw key. Placeholders are looked up
// last, so real translations take over as soon as they land - at which point this wrapper
// and config/i18n/placeholders/homepage/homepage.yml should both go.
export const Homepage = withI18nPlaceholders(I18N_PLACEHOLDERS, HomepageBase);
